import React from "react";
import ImageWrapper from "./ImageWrapper";
import Link from "next/link";

function CmsIntroImage({ component, page_id='' }) {
  return (
    <div id={`${component.id ?? ""}`}
    >
      {component.options.slides.map(function (slide, i) {
        var imageStyle =
        typeof slide.image.url != ""
          ? {
              backgroundImage: `url(${slide.image.url})`,
            }
          : {};
        return (
          <div key={i}>
            <div className="intro-image-component">
              <div className="image" style={imageStyle}>
              </div>
              <div
                className="caption"
                dangerouslySetInnerHTML={{ __html: slide.caption }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default CmsIntroImage;
